module.exports = __webpack_public_path__ + "img/unionpay.62fb4f77.svg";